export const HEADER_LINKS = [
  {
    name: "Home",
    isSingle: true,
    url: "/",
    isView: true,
  },
  {
    name: "Creation",
    isSingle: true,
    url: "/creation",
  },
  {
    name: "Story Board",
    isSingle: true,
    url: "/story-board",
  },
  {
    name: "Tickets",
    isSingle: true,
    url: "/tickets",
  },

  {
    name: "About Us",
    links: [
      { name: "About Us", url: "/about", isMain: true },
      { name: "Contact Us", url: "/contact-us" },
    ],
    isView: true,
  },
  {
    name: "Invest",
    isSingle: true,
    url: "/invest",
    isView: true,
  },
  // {
  //   name: "Coming Soon",
  //   isSingle: true,
  //   url: "/coming-soon",
  //   isView: true,
  // },
  {
    name: "Featured Comix",
    isSingle: true,
    url: "/featured-comix",
    isView: true,
  },
  // {
  //   name: "Community",
  //   isSingle: true,
  //   url: "/community",
  // },
  {
    name: "Help",
    isSingle: true,
    url: "/help-center",
    isView: true,
  },
  {
    name: "Author",
  },
];

export const FOOTER_LINKS = [
  {
    title: "My Account",
    links: [
      // {
      //   title: "Profile",
      //   url: "/author",
      // },
      {
        title: "Payment History",
        url: "/credit-payment-history",
      },
    ],
  },
  {
    title: "Information",
    links: [
      {
        title: "About Us",
        url: "/about",
      },
      {
        title: "Invest",
        url: "/invest",
      },
    ],
  },
  {
    title: "Contact & Support",
    links: [
      {
        title: "Support Creators",
        url: "/featured-comix",
      },
      {
        title: "Contact Us",
        url: "/contact-us",
      },
      // {
      //   title: "Help",
      //   url: "/help-center",
      // },
    ],
  },
];

export const SOCIAL_LINKS = [
  {
    icon: "facebook",
    url: "https://www.facebook.com/uecomix",
    name: "Facebook",
  },
  {
    icon: "youtube",
    url: "https://www.youtube.com/@uecomix/featured",
    name: "Youtube",
  },
  {
    icon: "instagram",
    url: "https://www.instagram.com/uecomix/",
    name: "Instagram",
  },
];

export const PROFILE_SOCIAL_LINKS = [
  {
    icon: "twitter",
    url: "https://twitter.com/",
    name: "Twitter",
  },
  {
    icon: "facebook",
    url: "https://facebook.com/",
    name: "Facebook",
  },
  {
    icon: "instagram",
    url: "https://instagram.com/",
    name: "Instagram",
  },
];
